<template>
  <div style="padding: 20px">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="圈品牌" name="brand"> </el-tab-pane>
      <el-tab-pane label="指定spu" name="spu"> </el-tab-pane>
      <brand v-if="activeTab == 'brand'" key="brand"></brand>
      <spu v-if="activeTab == 'spu'" key="spu"></spu>
    </el-tabs>
  </div>
</template>

<script>
import brand from "./brand.vue";
import spu from "./spu.vue";
export default {
  data() {
    return {
      activeTab: "brand",
    };
  },
  components: { brand, spu },
  created() {},
  mounted() {},
  methods: {
    handleClick(val) {
      console.log(val);
      this.activeTab = val;
    },
  },
};
</script>
<style lang="less" scoped>
.dialogContainer .el-checkbox {
  margin-left: 0;
  margin-right: 20px;
  margin-bottom: 5px;
}
.manipulate {
  margin-right: 12px;
  color: #409eff;
  cursor: pointer;
}
.dot {
  display: inline-block;
  margin-right: 8px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
.gray {
  background: #cccccc;
}
.green {
  background: green;
}
.dropdown-item {
  margin: 0;
  padding: 7px 16px;
  clear: both;
  color: #657180;
  font-size: 12px !important;
  white-space: nowrap;
  list-style: none;
  cursor: pointer;
  transition: background 0.2s ease-in-out;
}
.demo-ruleForm {
  margin: 20px 0px;
}
.flex {
  height: 80px;
  padding-top: 13px;
  padding-left: 10px;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}
.absolute {
  position: absolute;
  top: 0;
  left: 168px;
}
.upload-wrap {
  position: relative;
  display: inline-block;
  margin-left: 10px;

  input {
    position: absolute;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
    z-index: 10;
  }
}
</style>
